<div class="form-container">
    <h2>Create Recycling Option</h2>
  
    <form [formGroup]="recyclingForm" (ngSubmit)="createRecyclingOption()">
       <div class="form-group">
        <label for="scenarioCategoryId">Scenario Category:</label>
        <select class="form-control" formControlName="scenarioCategoryId" id="scenarioCategoryId">
          <option value="">Select Category</option>
          <option *ngFor="let category of categories" [value]="category.id">{{ category.title }}</option>
        </select>
        <div *ngIf="errors.scenarioCategoryId" class="text-danger">
          <ul><li *ngFor="let error of errors.scenarioCategoryId">{{ error }}</li></ul>
        </div>
      </div>
      <div class="form-group">
        <label>Title:</label>
        <input type="text" class="form-control" formControlName="title" placeholder="Recycling Title">
        <div *ngIf="errors.title" class="text-danger">
          <ul><li *ngFor="let error of errors.title">{{ error }}</li></ul>
        </div>
      </div>
  
      <div class="form-group">
        <label>Coefficient:</label>
        <input type="number" class="form-control" formControlName="coefficient" placeholder="Coefficient">
        <div *ngIf="errors.coefficient" class="text-danger">
          <ul><li *ngFor="let error of errors.coefficient">{{ error }}</li></ul>
        </div>
      </div>
  
      <div class="form-group">
        <label>Percentage:</label>
        <input type="number" class="form-control" formControlName="percentage" placeholder="Percentage">
        <div *ngIf="errors.percentage" class="text-danger">
          <ul><li *ngFor="let error of errors.percentage">{{ error }}</li></ul>
        </div>
      </div>
      <div class="form-group">
        <label>Description:</label>
        <textarea class="form-control" formControlName="description" placeholder="Optional description..." rows="3">
                          </textarea>
        <div *ngIf="errors.description" class="text-danger">
          <ul>
            <li *ngFor="let error of errors.description">{{ error }}</li>
          </ul>
        </div>
      </div>
     
  
      <div class="form-group">
        <label>Countries:</label>
        <div class="input-group mb-2">
          <select class="form-control" formControlName="countryInput">
            <option value="">Select a country</option>
            <option *ngFor="let country of availableCountries" [value]="country">{{ country }}</option>
          </select>
          <div class="input-group-append">
            <button type="button" class="btn btn-secondary" (click)="addCountry()">Add</button>
          </div>
        </div>
      
        <div>
          <span *ngFor="let country of selectedCountries" class="badge badge-primary mr-1">
            {{ country }}
            <button type="button" class="btn btn-sm btn-light ml-1" (click)="removeCountry(country)">×</button>
          </span>
        </div>
      </div>
      
  
      <div *ngIf="errors.general" class="text-danger">
        <ul><li *ngFor="let error of errors.general">{{ error }}</li></ul>
      </div>
  
      <button type="submit" class="btn btn-primary">
        {{ isSubmitting ? 'Submitting...' : 'Create Recycling Option' }}
      </button>
    </form>
  </div>
  